<template>
  <section class="programacion-card">
    <div v-if="agendamiento" class="card-content">

      <!-- Primera línea: Tipo, Tema y Estado -->
      <div class="card-main-row">
        <div class="type-badge" :class="tipoBadgeClass">
          <i :class="tipoIcon"></i>
          <span>{{ textoTipoClase }}</span>
        </div>

        <div v-if="textoTema" class="tema-section" :class="{ 'cancelado': agendamiento.estado == 'cancelado' }">
          <i class="ri-book-open-line tema-icon"></i>
          <span class="tema-text">{{ textoTema }}</span>
          <button
            v-if="agendamiento.tema && agendamiento.tema.notificacion_mostrar && agendamiento.tema.notificacion_texto"
            @click="mostrarNotificacionTema(agendamiento.tema)" class="btn-info-small">
            <i class="ri-information-line"></i>
          </button>
        </div>

        <div class="status-badge" :class="estadoBadgeClass">
          <i :class="estadoIcon"></i>
          <span>{{ textoEstado }}</span>
        </div>
      </div>

      <!-- Fecha cancelación si aplica -->
      <div v-if="fechaCancelado" class="cancel-info">
        <i class="ri-time-line"></i>
        <span>{{ fechaCancelado }}</span>
      </div>

      <!-- Información en línea compacta -->
      <div class="info-compact">
        <div class="info-item-inline">
          <i class="ri-calendar-line"></i>
          <span>{{ textoFechaClase }}</span>
        </div>

        <div v-if="textoSede" class="info-item-inline">
          <i class="ri-map-pin-line"></i>
          <span>{{ textoSede }}</span>
        </div>

        <div v-if="textoSalon" class="info-item-inline">
          <i class="ri-door-open-line"></i>
          <span v-html="textoSalon"></span>
        </div>

        <div v-if="docenteInfo" class="info-item-inline">
          <i class="ri-user-line"></i>
          <span>{{ docenteInfo }}</span>
        </div>
      </div>

      <!-- Información adicional (solo si existe) -->
      <div v-if="textoAsistenciaFecha || agendamiento.conformidad_fecha" class="info-secondary">
        <div v-if="textoAsistenciaFecha" class="info-item-inline">
          <i class="ri-check-line"></i>
          <span class="small-text">Asistencia: {{ textoAsistenciaFecha }}</span>
        </div>

        <div v-if="agendamiento.conformidad_fecha" class="info-item-inline">
          <i class="ri-checkbox-circle-line"></i>
          <span class="small-text">Confirmado: {{ textoConformidadFecha }}</span>
        </div>
      </div>

      <!-- Política de cancelación (solo si existe) -->
      <div v-if="textoPoliticaCancelacion" class="policy-alert">
        <i class="ri-error-warning-line"></i>
        <span>{{ textoPoliticaCancelacion }}</span>
      </div>

      <!-- Acciones (solo si hay alguna disponible) -->
      <div
        v-if="puedeCancelar || ([1, 0].includes(agendamiento.encuestar) && agendamiento.estado == 'asistido' && agendamiento.showEncuesta)"
        class="actions-section">
        <button v-if="puedeCancelar" @click="cancelando = true" class="btn-cancel">
          <i class="ri-close-circle-line"></i>
          Cancelar clase
        </button>

        <button
          v-if="[1, 0].includes(agendamiento.encuestar) && agendamiento.estado == 'asistido' && agendamiento.showEncuesta"
          @click="mostrarEncuesta" class="btn-survey">
          <i class="ri-chat-3-line"></i>
          EncuestaClase
        </button>
      </div>

    </div>

    <!-- Modal de confirmación de cancelación -->
    <b-modal hide-header-close v-model="cancelando" id="modalcancelarseguro" title="Cancelar clase"
      modal-class="modal-modern">
      <p class="mb-0">{{ textoConfirmarCancelar }}</p>
      <template #modal-footer>
        <b-btn variant="secondary" @click="cancelando = false">
          No, mantener mi clase
        </b-btn>
        <b-btn variant="primary" @click="procesarCancelar">
          Sí, cancelar mi clase
        </b-btn>
      </template>
    </b-modal>

    <!-- Modal de notificación del tema -->
    <b-modal no-close-on-backdrop hide-header-close ok-only ok-title="Entendido" v-model="mostrandoNotificacionTema"
      id="modalNotificacionTema" :title="tituloNotificacionTema" modal-class="modal-modern">
      <p>{{ textoNotificacionTema }}</p>
      <br>
      <p class="text-center">
        <b-link v-if="enlaceNotificacionTema" :href="enlaceNotificacionTema" target="_blank">
          Más información
        </b-link>
      </p>
    </b-modal>

    <EncuestaClase v-if="encuestaMostrar" :agendamiento="agendamiento" @cerrar="cerrarEncuesta" :mostrar="encuestaMostrar" />
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import EncuestaClase from '@/features/clases/components/EncuestaClase';
import utils from '@/modules/utils';

export default {
  name: 'ClaseProgramada',
  components: {
    EncuestaClase
  },
  props: {
    agendamiento: Object,
    estudiante: Object
  },
  data() {
    return {
      tema_id_local: null,
      texto_cambio_tipo: null,
      cambiando_tema: false,
      texto_cambio_tipo: null,
      cancelando: false,
      tituloNotificacionTema: null,
      mostrandoNotificacionTema: false,
      textoNotificacionTema: null,
      enlaceNotificacionTema: '#',
      encuestaMostrar: false
    }
  },

  mounted() {

  },
  methods: {
    ...mapActions({
      fetchClases: 'academico/fetchClases',
      cancelar: 'academico/cancelar',
      aceptar: 'academico/aceptar'
    }),
    ...mapMutations({

    }),
    recargar() {
      this.fetchClases().then(() => { })
    },

    procesarCancelar() {
      this.cancelar(this.agendamiento.id).then(() => {
      }).finally(() => {
        this.cancelando = false;
        // Emitir evento para recargar notificaciones
        this.$root.$emit('reload-notifications')
      })
    },
    procesarAceptar() {
      this.aceptar(this.agendamiento.id).then(() => {
      })
    },
    docent(docente) {
      if (docente) {
        docente = JSON.parse(docente)
        return docente.nombre
      }
      else { return "" }
    },
    mostrarNotificacionTema(tema) {
      if (tema && tema.notificacion_mostrar && tema.notificacion_texto) {
        this.mostrandoNotificacionTema = true;
        this.textoNotificacionTema = tema.notificacion_texto
        this.enlaceNotificacionTema = tema.notificacion_enlace;
        this.tituloNotificacionTema = tema.nombre;
      }
    },
    mostrarEncuesta() {
      this.encuestaMostrar = true;
    },
    cerrarEncuesta() {
      this.agendamiento.encuestar = null;
      this.encuestaMostrar = false;
    },
    addHoursToDate(objDate, intHours) {
      var numberOfMlSeconds = objDate.getTime();
      var addMlSeconds = (intHours * 60) * 60000;
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);
      return newDateObj;
    }
  },
  computed: {
    ...mapState({
      cursos: state => state.clases.cursos,
      sedeActual: state => state.academico.sedeActual,
    }),
    ...mapGetters({
      getCurso: 'cursos/getCursoDetalle',
    }),

    // Iconos y clases para badges
    tipoIcon() {
      const icons = {
        'normal': 'ri-book-2-line',
        'tutoria': 'ri-user-voice-line',
        'refuerzo': 'ri-flask-line',
        'asistente': 'ri-microscope-line',
        'lab': 'ri-test-tube-line'
      };
      return icons[this.agendamiento?.tipo_solicitud] || icons[this.agendamiento?.tipo_clase] || 'ri-book-line';
    },

    tipoBadgeClass() {
      const classes = {
        'normal': 'type-class',
        'tutoria': 'type-tutoria',
        'refuerzo': 'type-refuerzo',
        'asistente': 'type-lab',
        'lab': 'type-lab'
      };
      return classes[this.agendamiento?.tipo_solicitud] || classes[this.agendamiento?.tipo_clase] || 'type-class';
    },

    estadoIcon() {
      const estado = this.agendamiento?.estado;
      const icons = {
        'solicitado': 'ri-checkbox-circle-line',
        'asignado': 'ri-checkbox-circle-line',
        'notificado': 'ri-notification-3-line',
        'cancelado': 'ri-close-circle-line',
        'asistido': 'ri-check-double-line',
        'ausencia': 'ri-user-unfollow-line',
        'asistente': 'ri-user-follow-line',
        'aceptado': 'ri-medal-line'
      };
      return icons[estado] || 'ri-information-line';
    },

    estadoBadgeClass() {
      const estado = this.agendamiento?.estado;
      const classes = {
        'solicitado': 'status-confirmed',
        'asignado': 'status-confirmed',
        'notificado': 'status-notified',
        'cancelado': 'status-cancelled',
        'asistido': 'status-attended',
        'ausencia': 'status-absent',
        'asistente': 'status-assistant',
        'aceptado': 'status-accepted'
      };
      return classes[estado] || 'status-default';
    },

    docenteInfo() {
      if (this.agendamiento?.estudiante?.progresos && this.agendamiento?.tema_id) {
        const progreso = this.agendamiento.estudiante.progresos.find(
          ag => ag.tema_id === this.agendamiento.tema_id
        );
        if (progreso?.docente) {
          return this.docent(progreso.docente);
        }
      }
      return null;
    },

    puedeCancelar() {
      if (this.agendamiento) {
        if (this.agendamiento.estado == 'solicitado' || this.agendamiento.estado == 'asignado') {
          let ahora = new Date()
          if (this.agendamiento.politica_cancel_tiempo) {
            let deadline = new Date(this.agendamiento.politica_cancel_tiempo)
            if (ahora > deadline) {
              return false
            }
            return true
          } else {
            let fecha_clase = new Date(this.agendamiento.fecha_bloque)
            if (ahora > fecha_clase) {
              return false
            }
            return true
          }
        }
      }
      return false
    },
    puedeAceptar() {
      if (this.agendamiento) {
        if (this.agendamiento.tipo_solicitud == 'normal'
          && this.agendamiento.estado == 'asistido'
          && this.agendamiento.conformidad_fecha == null) {
          return true;
        }
      }
      return false
    },

    textoSalon() {
      if (this.agendamiento) {
        if (this.agendamiento.estado == 'cancelado') {
          return ''
        }
        if (this.agendamiento.clase && this.agendamiento.clase.salon) {
          let ahora = new Date()

          var dateUTC = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(), ahora.getUTCDate(), ahora.getUTCHours(), ahora.getUTCMinutes(), ahora.getUTCSeconds());
          dateUTC = this.addHoursToDate(dateUTC, -5)// Hora local de colombia
          // let ahoraTimestamp = ahora.getTime();
          let ahoraTimestamp = dateUTC.getTime();
          let limite = new Date(ahoraTimestamp + 300000)
          let fecha_bloque = new Date(this.agendamiento.fecha_bloque)
          let fecha_claseUTC = new Date(fecha_bloque.getUTCFullYear(), fecha_bloque.getUTCMonth(), fecha_bloque.getUTCDate(), fecha_bloque.getUTCHours(), fecha_bloque.getUTCMinutes(), fecha_bloque.getUTCSeconds());
          fecha_claseUTC = this.addHoursToDate(fecha_claseUTC, -5)// Hora local de colombia
          let fecha_clase = fecha_claseUTC;
          var dateUTCFinal = new Date(fecha_bloque.getUTCFullYear(), fecha_bloque.getUTCMonth(), fecha_bloque.getUTCDate(), fecha_bloque.getUTCHours(), fecha_bloque.getUTCMinutes(), fecha_bloque.getUTCSeconds());
          dateUTCFinal = this.addHoursToDate(dateUTCFinal, -5)// Hora local de colombia
          let fecha_clase_final = new Date(dateUTCFinal.getTime() + (300000 * 18))
          if ((limite > fecha_clase) || this.agendamiento.link_activo) {
            if (this.agendamiento.sede.es_virtual && this.agendamiento.sede.es_virtual == '1' && (limite < fecha_clase_final || this.agendamiento.link_activo)) {
              if (this.agendamiento.clase.salon && this.agendamiento.clase.salon.url) {
                return `<a href="${this.agendamiento.clase.salon.url}" target="_blank">${this.agendamiento.clase.salon.nombre}</a>`
              } else {
                return "Desconocido"
              }
            } else {
              let salon = this.agendamiento.clase.salon
              let texto = salon.nombre
              return texto
            }

          }
        }
      }
      return 'Puede verlo 5 minutos antes de la clase. Recuerde hacer click en Actualizar'
    },
    textoSede() {
      if (this.agendamiento && this.agendamiento.sede && this.agendamiento.sede.nombre) {
        return this.agendamiento.sede.nombre
      }
      return ''
    },
    textoTipoClase() {
      if (this.agendamiento) {
        let texto
        if (this.agendamiento.tipo_solicitud == 'normal') {
          texto = 'Clase'
        } else if (this.agendamiento.tipo_solicitud == 'tutoria') {
          texto = 'Tutoría'
        } else if (this.agendamiento.tipo_solicitud == 'refuerzo') {
          texto = 'Refuerzo'
        } else if (this.agendamiento.tipo_solicitud == 'asistente') {
          if (this.agendamiento.tipo_clase == 'lab') {
            texto = 'Laboratorio'
          } else {
            texto = this.agendamiento.tipo_clase
          }
        } else {
          texto = this.agendamiento.tipo_clase
        }
        return texto
      }
      return ''
    },
    textoTema() {
      if (this.agendamiento && this.agendamiento.tema) {
        let texto = this.agendamiento.tema.nombre
        return texto
      }
      return null
    },
    observaciones() {
      if (this.agendamiento && this.agendamiento.observaciones) {
        return JSON.parse(this.agendamiento.observaciones)
      }
      return null
    },
    textoFechaClase() {
      if (this.agendamiento) {
        if (this.agendamiento && [17, 30].includes(this.agendamiento.sede_id) && this.userTimeZone !== 'America/Bogota') {
          return utils.getDateTime(this.agendamiento.fecha_bloque)
        } else {
          let texto = this.agendamiento.fecha + ', ' + this.agendamiento.hora
          return texto;
        }

      }
      return ''
    },
    textoAsistenciaFecha() {
      if (this.agendamiento && this.agendamiento.asistencia_fecha) {
        if (this.agendamiento && [17, 30].includes(this.agendamiento.sede_id) && this.userTimeZone !== 'America/Bogota') {
          return utils.getDateTime(this.agendamiento.asistencia_fecha)
        }
        else {
          let asistencia_fecha = new Date(this.agendamiento.asistencia_fecha).toLocaleString('es-CO', { timeZone: "America/Bogota" })
          return asistencia_fecha
        }
      }
      return null
    },
    observacionCancelado() {
      if (this.agendamiento) {
        if (this.agendamiento.estado == 'cancelado') {
          if (this.agendamiento.observaciones) {
            let observaciones = JSON.parse(this.agendamiento.observaciones)
            let ultimaObservacion = observaciones.pop()
            if (ultimaObservacion && ultimaObservacion.texto) {
              if (ultimaObservacion.texto.indexOf('Cancelado') >= 0) {
                return ultimaObservacion
              }
            }

          }
        }
      }
      return null
    },
    fechaCancelado() {
      let observacionCancelado = this.observacionCancelado
      if (observacionCancelado && observacionCancelado.fecha) {
        if (this.agendamiento && [17, 30].includes(this.agendamiento.sede_id) && this.userTimeZone !== 'America/Bogota') {
          return utils.getDateTime(observacionCancelado.fecha);
        } else {
          let fechaCancelado = new Date(observacionCancelado.fecha)
          if (fechaCancelado.toString() === 'Invalid Date') return observacionCancelado.fecha;
          return fechaCancelado.toLocaleString('es-CO', { timeZone: "America/Bogota" })
        }
      }
    },
    textoEstado() {
      if (this.agendamiento) {
        if (this.agendamiento.estado == 'solicitado') {
          return 'Confirmado'
        } else if (this.agendamiento.estado == 'asignado') {
          return 'Confirmado'
        } else if (this.agendamiento.estado == 'notificado') {
          return 'Notificado'
        } else if (this.agendamiento.estado == 'cancelado') {
          let canceladoTexto = 'Cancelado'
          let observacionCancelado = this.observacionCancelado
          if (observacionCancelado && observacionCancelado.texto) {
            canceladoTexto = observacionCancelado.texto
          }
          return canceladoTexto
        } else if (this.agendamiento.estado == 'asistido') {
          return 'Confirmado'
        } else if (this.agendamiento.estado == 'ausencia') {
          return 'Ausente'
        } else if (this.agendamiento.estado == 'asistente') {
          return 'Asistente'
        } else if (this.agendamiento.estado == 'aceptado') {
          return 'Aceptado'
        } else {
          return this.agendamiento.estado
        }
      }
      return ''
    },
    textoConformidadFecha() {
      if (this.agendamiento && this.agendamiento.conformidad_fecha) {
        if (this.agendamiento && [17, 30].includes(this.agendamiento.sede_id) && this.userTimeZone !== 'America/Bogota') {
          return utils.getDateTime(this.agendamiento.conformidad_fecha);
        } else {
          let conformidad_fecha = new Date(this.agendamiento.conformidad_fecha).toLocaleString('es-CO', { timeZone: "America/Bogota" })
          return conformidad_fecha
        }
      }
      return 'Pendiente'
    },
    textoConfirmarCancelar() {
      let texto = "¡RECUERDA! solo podrás CANCELAR clase con 24 HORAS de anticipación. Esto con el fin de que otros compañeros tengan el cupo abierto y puedan programar clases. No dejes de Avanzar."
      return texto + ' ¿Estás seguro que deseas cancelar tu clase de ' + this.textoFechaClase + '?'
    },

    textoPoliticaCancelacion() {
      if (this.agendamiento.estado != 'cancelado') {
        return this.agendamiento.politica_cancel_mensaje ? this.agendamiento.politica_cancel_mensaje : false;
      }
      return false
    },
    zonaRegional() {
      if (this.agendamiento && [17, 30].includes(this.agendamiento.sede_id) && this.userTimeZone !== 'America/Bogota') {
        return `${this.userTimeZone}`;
      } else {
        return 'America/Bogota'

      }
    },
    userTimeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
  }
}
</script>

<style scoped>
/* ============================================================================
   TARJETA DE PROGRAMACIÓN COMPACTA
   ============================================================================ */
.programacion-card {
  width: 100%;
  margin-bottom: 0.5rem;
}

.card-content {
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 10px;
  padding: 0.75rem 1rem;
  transition: all 0.2s ease;
  box-shadow: var(--theme-shadow-sm);
}

.card-content:hover {
  box-shadow: var(--theme-shadow-md);
  border-color: var(--app-primary-blue);
}

/* ============================================================================
   PRIMERA LÍNEA: TIPO + TEMA + ESTADO
   ============================================================================ */
.card-main-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
}

/* Badges compactos */
.type-badge,
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.type-badge i,
.status-badge i {
  font-size: 0.875rem;
}

/* Colores de tipo */
.type-class {
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-primary);
  border: 1px solid var(--theme-border-color);
}

.type-tutoria {
  background: rgba(139, 92, 246, 0.15);
  color: #7c3aed;
  border: 1px solid rgba(139, 92, 246, 0.3);
}

.type-refuerzo {
  background: rgba(251, 146, 60, 0.15);
  color: #ea580c;
  border: 1px solid rgba(251, 146, 60, 0.3);
}

.type-lab {
  background: rgba(34, 197, 94, 0.15);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

/* Colores de estado */
.status-confirmed {
  background: rgba(34, 197, 94, 0.15);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.status-notified {
  background: rgba(59, 130, 246, 0.15);
  color: #2563eb;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

.status-cancelled {
  background: rgba(239, 68, 68, 0.15);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.status-attended {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.status-absent {
  background: rgba(249, 115, 22, 0.15);
  color: #ea580c;
  border: 1px solid rgba(249, 115, 22, 0.3);
}

.status-assistant {
  background: rgba(168, 85, 247, 0.15);
  color: #9333ea;
  border: 1px solid rgba(168, 85, 247, 0.3);
}

.status-accepted {
  background: rgba(52, 211, 153, 0.15);
  color: #10b981;
  border: 1px solid rgba(52, 211, 153, 0.3);
}

.status-default {
  background: var(--theme-hover-bg-light);
  color: var(--theme-text-secondary);
  border: 1px solid var(--theme-border-color);
}

/* ============================================================================
   TEMA EN LÍNEA
   ============================================================================ */
.tema-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
}

.tema-icon {
  color: var(--app-primary-blue);
  font-size: 1rem;
  flex-shrink: 0;
}

.tema-text {
  flex: 1;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--theme-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tema-section.cancelado .tema-text {
  text-decoration: line-through;
  opacity: 0.6;
}

.btn-info-small {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: rgba(79, 172, 254, 0.15);
  border: 1px solid rgba(79, 172, 254, 0.3);
  border-radius: 4px;
  color: var(--app-primary-blue);
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;
}

.btn-info-small:hover {
  background: rgba(79, 172, 254, 0.25);
  transform: scale(1.1);
}

.btn-info-small i {
  font-size: 0.875rem;
}

/* ============================================================================
   INFORMACIÓN DE CANCELACIÓN
   ============================================================================ */
.cancel-info {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.75rem;
  color: var(--theme-text-muted);
  margin-bottom: 0.5rem;
}

.cancel-info i {
  font-size: 0.875rem;
}

/* ============================================================================
   INFORMACIÓN COMPACTA EN LÍNEA
   ============================================================================ */
.info-compact {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.info-item-inline {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8125rem;
  color: var(--theme-text-primary);
}

.info-item-inline i {
  color: var(--app-primary-blue);
  font-size: 0.875rem;
  flex-shrink: 0;
}

.info-item-inline span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ============================================================================
   INFORMACIÓN SECUNDARIA
   ============================================================================ */
.info-secondary {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
  padding: 0.375rem 0.5rem;
  background: var(--theme-hover-bg-light);
  border-radius: 6px;
}

.small-text {
  font-size: 0.75rem;
  color: var(--theme-text-secondary);
}

/* ============================================================================
   ALERTA DE POLÍTICA
   ============================================================================ */
.policy-alert {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.5rem 0.625rem;
  background: rgba(251, 146, 60, 0.1);
  border: 1px solid rgba(251, 146, 60, 0.3);
  border-radius: 6px;
  margin-bottom: 0.5rem;
}

.policy-alert i {
  color: #ea580c;
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.policy-alert span {
  font-size: 0.75rem;
  color: var(--theme-text-primary);
  line-height: 1.4;
}

/* ============================================================================
   ACCIONES
   ============================================================================ */
.actions-section {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.btn-cancel,
.btn-survey {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border: none;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.btn-cancel:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

.btn-survey {
  background: var(--theme-gradient-primary);
  color: white;
}

.btn-survey:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(13, 78, 140, 0.3);
}

.btn-cancel i,
.btn-survey i {
  font-size: 0.875rem;
}

/* ============================================================================
   RESPONSIVE
   ============================================================================ */
@media (max-width: 768px) {
  .card-content {
    padding: 0.625rem 0.875rem;
  }

  .card-main-row {
    flex-direction: column;
    align-items: stretch;
    gap: 0.375rem;
  }

  .type-badge,
  .status-badge {
    width: 100%;
    justify-content: center;
  }

  .tema-section {
    width: 100%;
  }

  .tema-text {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  .info-compact {
    flex-direction: column;
    gap: 0.5rem;
  }

  .info-item-inline {
    width: 100%;
  }

  .info-item-inline span {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  .actions-section {
    flex-direction: column;
  }

  .btn-cancel,
  .btn-survey {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .card-content {
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
  }

  .type-badge {
    display: none;
  }

  .status-badge {
    font-size: 0.6875rem;
    padding: 0.25rem 0.5rem;
  }

  .tema-text {
    font-size: 0.8125rem;
  }

  .info-item-inline {
    font-size: 0.75rem;
  }
}
</style>
<style src="../../../assets/styles/shared-modals.css"></style>
